import { combineReducers } from "redux";

import { amenitiesDetails } from "./reducer.amenities"
const amenityReducers = combineReducers({

  amenitiesDetails

})
export default amenityReducers;
